import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

// RX-2454: Hotfix for Odin v2
// Should be changed to NavFlow.TAB and Tab.USAGE once customers are upgraded to Odin's V3 (or removed this intent completely - the same path is handled in service.ts)
export const serviceElectricityUsage: IMcAppType = {
  name: "serviceElectricityUsage",
  path: "/my/usage/electricity",
  description: "Electricity Usage",
  navFlow: NavFlow.FOCUS,
  title: "Usage",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "serviceElectricityUsage",
    customerType: CustomerType.kraken,
  },
};
